import script from "./MyLive.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyLive.vue?vue&type=script&lang=ts&setup=true"

import "./MyLive.vue?vue&type=style&index=0&id=dd47bf20&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd47bf20"]])

export default __exports__